import { Injectable, inject } from '@angular/core';
import { Skill, ToolsCollection } from '@dges/modules/portfolio/domain';
import { Observable } from 'rxjs';
import {
  Firestore,
  CollectionReference,
  DocumentReference,
  collection,
  collectionData,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class ToolsCollectionService implements ToolsCollection {
  private firestore = inject(Firestore);

  private toolsCollection = collection(
    this.firestore,
    'tools',
  ) as CollectionReference<Skill>;

  public getTools(): Observable<Skill[]> {
    return collectionData(this.toolsCollection, {
      idField: 'id',
    }) as Observable<Skill[]>;
  }

  public addTool(tool: Skill): Promise<DocumentReference<Skill>> {
    return addDoc(this.toolsCollection, tool);
  }

  public editTool(tool: Skill): Promise<void> {
    return updateDoc(doc(this.toolsCollection, String(tool.id)), { ...tool });
  }

  public deleteTool(tool: Skill): Promise<void> {
    return deleteDoc(doc(this.toolsCollection, String(tool.id)));
  }
}
